import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image } from '../types'
import { MacsMapItemData } from './macs-map-item/macs-map-item.component.converter'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class MacsMapConverter extends CmsConverterService<MacsMapData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData?.st_title_text.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      items: formData.st_map_items ?? defaultFSCatalog
    }
  }
}

export const MACS_MAP_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, MacsMapData>>('MacsMapConverter')

export interface MacsMapData extends ConvertedComponentData {
  image: Image;
  items: FsCatalog<MacsMapItemData>;
}

